
export const auditCreationSchema = [];
// export const auditCreationSchema = {
//   title: "lorem ipusm",
//   isDraft: true,
//   createdBy: "",
//   publishedDate: "",
//   sections: [
//     {
//       title: "Section one",
//       fieldset: [
//         {
//           id: generateUniqueId(10),
//           title: "Question one",
//           inputType: "numeric",
//           options: [
//             {
//               name: "yes",
//               checked: false,
//               value: 1,
//             },
//             {
//               name: "no",
//               checked: false,
//               value: 2,
//             },
//             {
//               name: "na",
//               checked: false,
//               value: 3,
//             },
//           ],
//           value: "",
//           questionScore: 0,
//           score: [
//             {
//               name: "gt",
//               value: 6,
//               score: 5,
//             },
//             {
//               name: "lt",
//               value: 10,
//               score: 8,
//             },
//           ],
//           slider: false,
//           open: false,
//           required: true,
//           hint: "",
//           allowImageUpload: false,
//           image: "",
//           imageName: "",
//           nc: {
//             type: "",
//             comment: "",
//             clause: "",
//             severity: "",
//              evidence:"",
//               mainComments:"",
//           },
//         },
//         {
//           id: generateUniqueId(10),
//           title: "Question two",
//           inputType: "radio",
//           options: [
//             {
//               name: "yes",
//               checked: false,
//               value: 1,
//             },
//             {
//               name: "no",
//               checked: false,
//               value: 2,
//             },
//             {
//               name: "na",
//               checked: false,
//               value: 3,
//             },
//           ],
//           value: "no",
//           questionScore: 0,
//           score: [
//             {
//               name: "gt",
//               value: 0,
//               score: 0,
//             },
//             {
//               name: "lt",
//               value: 0,
//               score: 0,
//             },
//           ],
//           slider: false,
//           open: false,
//           required: true,
//           hint: "",
//           allowImageUpload: true,
//           image: "",
//           imageName: "",
//           nc: {
//             type: "",
//             comment: "",
//             clause: "",
//             severity: "",
// mainComments:"",
//           },
//         },
//         {
//           id: generateUniqueId(10),
//           title: "Question three",
//           inputType: "checkbox",
//           options: [
//             {
//               name: "yes",
//               checked: false,
//               value: 10,
//             },
//             {
//               name: "no",
//               checked: false,
//               value: 5,
//             },
//             {
//               name: "na",
//               checked: false,
//               value: 0,
//             },
//           ],
//           value: "",
//           questionScore: 0,
//           score: [
//             {
//               name: "gt",
//               value: 0,
//               score: 0,
//             },
//             {
//               name: "lt",
//               value: 0,
//               score: 0,
//             },
//           ],
//           slider: false,
//           open: false,
//           required: true,
//           hint: "",
//           allowImageUpload: true,
//           image: "",
//           imageName: "",
//           nc: {
//             type: "",
//             comment: "",
//             clause: "",
//             severity: "",
// mainComments:"",
//           },
//         },
//         {
//           id: generateUniqueId(10),
//           title: "Question four",
//           inputType: "text",
//           options: [
//             {
//               name: "yes",
//               checked: false,
//               value: 0,
//             },
//             {
//               name: "no",
//               checked: false,
//               value: 0,
//             },
//             {
//               name: "na",
//               checked: false,
//               value: 0,
//             },
//           ],
//           value: "",
//           questionScore: 0,
//           score: [
//             {
//               name: "gt",
//               value: 0,
//               score: 0,
//             },
//             {
//               name: "lt",
//               value: 0,
//               score: 0,
//             },
//           ],
//           slider: false,
//           open: false,
//           required: true,
//           hint: "",
//           allowImageUpload: true,
//           image: "",
//           imageName: "",
//           nc: {
//             type: "",
//             comment: "",
//             clause: "",
//             severity: "",
// mainComments:"",
//             evidence:""
//           },
//         },
//       ],
//     },
//     {
//       title: "Section one",
//       fieldset: [
//         {
//           id: generateUniqueId(10),
//           title: "Question one",
//           inputType: "numeric",
//           options: [
//             {
//               name: "yes",
//               checked: false,
//               value: 1,
//             },
//             {
//               name: "no",
//               checked: false,
//               value: 2,
//             },
//             {
//               name: "na",
//               checked: false,
//               value: 3,
//             },
//           ],
//           value: "",
//           questionScore: 0,
//           score: [
//             {
//               name: "gt",
//               value: 6,
//               score: 5,
//             },
//             {
//               name: "lt",
//               value: 10,
//               score: 8,
//             },
//           ],
//           slider: false,
//           open: false,
//           required: true,
//           hint: "",
//           allowImageUpload: false,
//           image: "",
//           imageName: "",
//           nc: {
//             type: "",
//             comment: "",
//             clause: "",
//             severity: "",
// mainComments:"",
//           },
//         },
//         {
//           id: generateUniqueId(10),
//           title: "Question two",
//           inputType: "radio",
//           options: [
//             {
//               name: "yes",
//               checked: false,
//               value: 1,
//             },
//             {
//               name: "no",
//               checked: false,
//               value: 2,
//             },
//             {
//               name: "na",
//               checked: false,
//               value: 3,
//             },
//           ],
//           value: "",
//           questionScore: 0,
//           score: [
//             {
//               name: "gt",
//               value: 0,
//               score: 0,
//             },
//             {
//               name: "lt",
//               value: 0,
//               score: 0,
//             },
//           ],
//           slider: false,
//           open: false,
//           required: true,
//           hint: "",
//           allowImageUpload: true,
//           image: "",
//           imageName: "",
//           nc: {
//             type: "",
//             comment: "",
//             clause: "",
//             severity: "",
// mainComments:"",
//           },
//         },
//         {
//           id: generateUniqueId(10),
//           title: "Question three",
//           inputType: "checkbox",
//           options: [
//             {
//               name: "yes",
//               checked: false,
//               value: 10,
//             },
//             {
//               name: "no",
//               checked: false,
//               value: 5,
//             },
//             {
//               name: "na",
//               checked: false,
//               value: 0,
//             },
//           ],
//           value: "",
//           questionScore: 0,
//           score: [
//             {
//               name: "gt",
//               value: 0,
//               score: 0,
//             },
//             {
//               name: "lt",
//               value: 0,
//               score: 0,
//             },
//           ],
//           slider: false,
//           open: false,
//           required: true,
//           hint: "",
//           allowImageUpload: true,
//           image: "",
//           imageName: "",
//           nc: {
//             type: "",
//             comment: "",
//             clause: "",
//             severity: "",
// mainComments:"",
//           },
//         },
//         {
//           id: generateUniqueId(10),
//           title: "Question four",
//           inputType: "text",
//           options: [
//             {
//               name: "yes",
//               checked: false,
//               value: 0,
//             },
//             {
//               name: "no",
//               checked: false,
//               value: 0,
//             },
//             {
//               name: "na",
//               checked: false,
//               value: 0,
//             },
//           ],
//           value: "",
//           questionScore: 0,
//           score: [
//             {
//               name: "gt",
//               value: 0,
//               score: 0,
//             },
//             {
//               name: "lt",
//               value: 0,
//               score: 0,
//             },
//           ],
//           slider: false,
//           open: false,
//           required: true,
//           hint: "",
//           allowImageUpload: true,
//           image: "",
//           imageName: "",
//           nc: {
//             type: "",
//             comment: "",
//             clause: "",
//             severity: "",
// mainComments:"",
//           },
//         },
//       ],
//     },
//     // {
//     //   title: "Section two",
//     //   fieldset: [
//     //     {
//     //       id: generateUniqueId(10),
//     //       title: "Question one",
//     //       inputType: "text",
//     //       options: [
//     //         {
//     //           name: "yes",
//     //           checked: false,
//     //           value: 0,
//     //         },
//     //         {
//     //           name: "no",
//     //           checked: false,
//     //           value: 0,
//     //         },
//     //         {
//     //           name: "na",
//     //           checked: false,
//     //           value: 0,
//     //         },
//     //       ],
//     //       value: "",
//     //       score: [
//     //         {
//     //           name: "gt",
//     //           value: 0,
//     //           score: 0,
//     //         },
//     //         {
//     //           name: "lt",
//     //           value: 0,
//     //           score: 0,
//     //         },
//     //       ],
//     //       slider: false,
//     //       open: false,
//     //       required: true,
//     //       hint: "",
//     //       allowImageUpload: true,
//     //       image: "",
//     //       nc: {
//     //         type: "",
//     //         comment: "",
//     //         clause: "",
//     //         severity: "",
//  //              mainComments:"",
//     //       },
//     //     },
//     //     {
//     //       id: generateUniqueId(10),
//     //       title: "Question two ",
//     //       inputType: "checkbox",
//     //       options: [
//     //         {
//     //           name: "yes",
//     //           checked: false,
//     //           value: 2,
//     //         },
//     //         {
//     //           name: "no",
//     //           checked: false,
//     //           value: 4,
//     //         },
//     //         {
//     //           name: "na",
//     //           checked: false,
//     //           value: 0,
//     //         },
//     //       ],
//     //       value: "",
//     //       score: [
//     //         {
//     //           name: "gt",
//     //           value: 0,
//     //           score: 0,
//     //         },
//     //         {
//     //           name: "lt",
//     //           value: 0,
//     //           score: 0,
//     //         },
//     //       ],
//     //       slider: false,
//     //       open: false,
//     //       required: true,
//     //       hint: "",
//     //       allowImageUpload: true,
//     //       image: "",
//     //       nc: {
//     //         type: "",
//     //         comment: "",
//     //         clause: "",
//     //         severity: "",
// //               mainComments:"",
//     //       },
//     //     },
//     //   ],
//     // },
//   ],
//   questionCount: 10,
//   totalScore: 0,
//   createdAt: "",
//   updatedAt: "",
// };
